import { Button, Grid, Typography, styled, useTheme } from "@mui/material";
import {
  ChartPie,
  ConvertIcon,
  DepositIcon,
  PaymentIcon,
  TradeIcon,
  WithdrawIcon,
} from "assets/Icon";

import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "routes/paths";

function QuickAccessButtons() {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Grid container spacing={2} mt={2}>
      <Grid item xs={4}>
        <QuickAccessButton
          onClick={() => navigate(ROUTE_PATHS.trade.basic("1", "3"))}
          variant="text"
        >
          <TradeIcon color={theme.palette.secondary.main} />
          <Typography variant="subtitle2" color="text.main">
            Trade
          </Typography>
        </QuickAccessButton>
      </Grid>

      <Grid item xs={4}>
        <QuickAccessButton onClick={() => navigate("/convert")} variant="text">
          <ConvertIcon color={theme.palette.secondary.main} />
          <Typography variant="subtitle2" color="text.main">
            Convert
          </Typography>
        </QuickAccessButton>
      </Grid>

      <Grid item xs={4}>
        <QuickAccessButton
          onClick={() => navigate("/portfolio")}
          variant="text"
        >
          <ChartPie color={theme.palette.secondary.main} stroke={1} />
          <Typography variant="subtitle2" color="text.main">
            Portfolio
          </Typography>
        </QuickAccessButton>
      </Grid>

      <Grid item xs={4}>
        <QuickAccessButton
          onClick={() => navigate("/withdraw/1")}
          variant="text"
        >
          <WithdrawIcon color={theme.palette.secondary.main} />
          <Typography variant="subtitle2" color="text.main">
            Withdraw
          </Typography>
        </QuickAccessButton>
      </Grid>

      <Grid item xs={4}>
        <QuickAccessButton
          onClick={() => navigate("/deposit/1")}
          variant="text"
        >
          <DepositIcon color={theme.palette.secondary.main} />
          <Typography variant="subtitle2" color="text.main">
            Deposit
          </Typography>
        </QuickAccessButton>
      </Grid>

      <Grid item xs={4}>
        <QuickAccessButton
          variant="text"
          onClick={() => navigate(`/deposit/4?type=4`)}
        >
          <PaymentIcon color={theme.palette.secondary.main} />
          <Typography variant="subtitle2" color="text.main">
            Payment <br /> Gateway
          </Typography>
        </QuickAccessButton>
      </Grid>
    </Grid>
  );
}

const QuickAccessButton = styled(Button)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  color: theme.palette.common.white,
  width: "100%",

  svg: {
    width: "34px",
    height: "34px",
    marginBottom: theme.spacing(1),
  },
}));

export default QuickAccessButtons;
